(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bmg-video"] && !Shopify.designMode) return;
  try {
    (()=>{
    let opener, previousOverflow;
    const getDialog=()=>document.getElementById('BmgVideoDialog');
    document.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-bmg-open]');
      if(!trigger)return;
      const dialog=getDialog();if(!dialog)return;
      event.preventDefault();event.stopImmediatePropagation();
      opener=trigger;previousOverflow=document.body.style.overflow;
      dialog.showModal();document.body.style.overflow='hidden';
      dialog.querySelector('[data-bmg-close]').focus();
      dialog.querySelector('video').play().catch(()=>{});
    },true);
    const bind=()=>{
      const dialog=getDialog();if(!dialog||dialog.dataset.bound)return;
      dialog.dataset.bound='true';
      dialog.querySelector('[data-bmg-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{const video=dialog.querySelector('video');video.pause();video.currentTime=0;document.body.style.overflow=previousOverflow||'';opener?.focus();});
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
    document.addEventListener('shopify:section:load',bind);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ceo-video"] && !Shopify.designMode) return;
  try {
    (()=>{
    let opener, previousOverflow;
    const getDialog=()=>document.getElementById('CeoVideoDialog');
    document.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-ceo-open]');
      if(!trigger)return;
      const dialog=getDialog();if(!dialog)return;
      event.preventDefault();event.stopImmediatePropagation();
      opener=trigger;previousOverflow=document.body.style.overflow;
      dialog.showModal();document.body.style.overflow='hidden';
      dialog.querySelector('[data-ceo-close]').focus();
      dialog.querySelector('video').play().catch(()=>{});
    },true);
    const bind=()=>{
      const dialog=getDialog();if(!dialog||dialog.dataset.bound)return;
      dialog.dataset.bound='true';
      dialog.querySelector('[data-ceo-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{const video=dialog.querySelector('video');video.pause();video.currentTime=0;document.body.style.overflow=previousOverflow||'';opener?.focus();});
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
    document.addEventListener('shopify:section:load',bind);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mom-video"] && !Shopify.designMode) return;
  try {
    (()=>{
    let opener, previousOverflow;
    const getDialog=()=>document.getElementById('MomVideoDialog');
    document.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-mom-open]');
      if(!trigger)return;
      const dialog=getDialog();if(!dialog)return;
      event.preventDefault();event.stopImmediatePropagation();
      opener=trigger;previousOverflow=document.body.style.overflow;
      dialog.showModal();document.body.style.overflow='hidden';
      dialog.querySelector('[data-mom-close]').focus();
      dialog.querySelector('video').play().catch(()=>{});
    },true);
    const bind=()=>{
      const dialog=getDialog();if(!dialog||dialog.dataset.bound)return;
      dialog.dataset.bound='true';
      dialog.querySelector('[data-mom-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{const video=dialog.querySelector('video');video.pause();video.currentTime=0;document.body.style.overflow=previousOverflow||'';opener?.focus();});
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
    document.addEventListener('shopify:section:load',bind);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["offers-video"] && !Shopify.designMode) return;
  try {
    (()=>{
    let opener, previousOverflow;
    const getDialog=()=>document.getElementById('OffersVideoDialog');
    document.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-offers-open]');
      if(!trigger)return;
      const dialog=getDialog();if(!dialog)return;
      event.preventDefault();event.stopImmediatePropagation();
      opener=trigger;previousOverflow=document.body.style.overflow;
      dialog.showModal();document.body.style.overflow='hidden';
      dialog.querySelector('[data-offers-close]').focus();
      dialog.querySelector('video').play().catch(()=>{});
    },true);
    const bind=()=>{
      const dialog=getDialog();if(!dialog||dialog.dataset.bound)return;
      dialog.dataset.bound='true';
      dialog.querySelector('[data-offers-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{const video=dialog.querySelector('video');video.pause();video.currentTime=0;document.body.style.overflow=previousOverflow||'';opener?.focus();});
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
    document.addEventListener('shopify:section:load',bind);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["profit-video"] && !Shopify.designMode) return;
  try {
    (()=>{
    let opener, previousOverflow;
    const getDialog=()=>document.getElementById('ProfitVideoDialog');
    document.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-profit-open]');
      if(!trigger)return;
      const dialog=getDialog();if(!dialog)return;
      event.preventDefault();event.stopImmediatePropagation();
      opener=trigger;previousOverflow=document.body.style.overflow;
      dialog.showModal();document.body.style.overflow='hidden';
      dialog.querySelector('[data-profit-close]').focus();
      dialog.querySelector('video').play().catch(()=>{});
    },true);
    const bind=()=>{
      const dialog=getDialog();if(!dialog||dialog.dataset.bound)return;
      dialog.dataset.bound='true';
      dialog.querySelector('[data-profit-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{const video=dialog.querySelector('video');video.pause();video.currentTime=0;document.body.style.overflow=previousOverflow||'';opener?.focus();});
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
    document.addEventListener('shopify:section:load',bind);
  })();
  } catch(e) { console.error(e); }
})();

})();
